module.exports = __webpack_public_path__ + "img/d6fece8a52366f336b42cdba7f5a337a.png";